<template>
    <!-- 搜索导航栏 -->
    <div class="search-nav">
        <!-- logo -->
        <div class="logo">
            <img src="../../../../assets/logo.png"
                 @click="$router.push('/home')"
                 alt="">
        </div>
        <!-- 搜索框 -->
        <div class="search">
            <SearchBar />
        </div>


        <!-- 用户 -->
        <div class="user">

        </div>
    </div>
</template>

<script>
    import SearchBar from '@/components/SearchBar.vue';
    export default {
        name: "SearchNav",
        components:{
            SearchBar
        }
    }
</script>

<style scoped lang="less">

</style>
<style lang="less">
    .search-nav{
        display: flex;
        align-items: center;
        justify-content: flex-start;
        /* logo */
        .logo{
            padding-left: 20px;
            box-sizing: border-box;
            width: 40%;
            img{
                height: 70px;
                cursor: pointer;
            }
        }
        /* 搜索框 */
        .search{
            input{
                color: #606266 !important;
            }
        }
    }
</style>